/*! @azure/msal-common v15.8.1 2025-07-08 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.8.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
